import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

export const GoogleMapsLoader = ({ children }) => (
  <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
    {children}
  </APIProvider>
);